import { c as _c } from "react/compiler-runtime";
interface BaseIconProps {
  className?: string;
}
export function BaseIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect width="40" height="40" fill="white" rx="20" />;
    t2 = <path d="M10.0798 11.6474C10.0798 11.1106 10.0798 10.8421 10.181 10.6357C10.2778 10.438 10.4377 10.2781 10.6354 10.1812C10.8419 10.0801 11.1103 10.0801 11.6472 10.0801H28.3525C28.8893 10.0801 29.1578 10.0801 29.3643 10.1812C29.562 10.2781 29.7218 10.438 29.8187 10.6357C29.9198 10.8421 29.9198 11.1106 29.9198 11.6474V28.3527C29.9198 28.8896 29.9198 29.158 29.8187 29.3645C29.7218 29.5622 29.562 29.7221 29.3643 29.8189C29.1578 29.9201 28.8893 29.9201 28.3525 29.9201H11.6472C11.1103 29.9201 10.8419 29.9201 10.6354 29.8189C10.4377 29.7221 10.2778 29.5622 10.181 29.3645C10.0798 29.158 10.0798 28.8896 10.0798 28.3527V11.6474Z" fill="#0000FF" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}